enum FormFields {
  Avatar = 'avatar',
  AgencyName = 'agencyName',
  AgencyWebsite = 'agencyWebsite',
  ShortDescription = 'shortDescription',
  Place = 'place',
  Radius = 'radius',
  BrokerLicenseNumber = 'brokerLicenseNumber',
  PhoneNumber = 'phoneNumber',
  PhoneNumberDialCode = 'phoneNumberDialCode',
  PhoneNumberVerificationCode = 'phoneNumberVerificationCode',
  PhoneNumberStatus = 'phoneNumberStatus',
  FirstName = 'firstName',
  LastName = 'lastName',
  WorkingHours = 'workingHours',
  VerifyPhoneNumberCode = 'verifyPhoneNumberCode',
  VerifyPhoneNumber = 'verifyPhoneNumber',
  BrokerLicenseStatus = 'brokerLicenseStatus',
  State = 'state',
}

const FormFieldsList = [
  FormFields.Avatar,
  FormFields.AgencyName,
  FormFields.AgencyWebsite,
  FormFields.ShortDescription,
  FormFields.Place,
  FormFields.Radius,
  FormFields.PhoneNumber,
  FormFields.FirstName,
  FormFields.LastName,
  FormFields.WorkingHours,
  FormFields.BrokerLicenseNumber,
  FormFields.PhoneNumberDialCode,
  FormFields.PhoneNumberVerificationCode,
  FormFields.VerifyPhoneNumberCode,
  FormFields.VerifyPhoneNumber,
  FormFields.BrokerLicenseStatus,
  FormFields.State,
];

export { FormFields, FormFieldsList };
